import { render } from "./NavgatorAt.vue?vue&type=template&id=af399428"
import script from "./NavgatorAt.vue?vue&type=script&lang=js"
export * from "./NavgatorAt.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__